import { _fetch } from '../../_fetch';

export const SET_COMMENTS = "SET_COMMENTS";
export const SET_QUERIES = "SET_QUERIES";
export const SET_FY_COUNT = "SET_FY_COUNT";
export const SET_TOTAL_ENTITIES = "SET_TOTAL_ENTITIES";

// thunk to fetch comments
export const fetchComments = () => {
    return async (dispatch) => {
        try {
            const res = await _fetch(`${process.env.REACT_APP_API_URL}/comment/my-last-comments`);
            const data = await res.json();
            console.log("[fetchComments] API response:", data);


            dispatch({
                type: SET_COMMENTS,
                payload: {
                    totalMails: data.unread_mails || 0,
                    last5Comments: data.last5Comments || [],
                },
            });
        } catch (err) {
            console.error("Error fetching comments:", err);
        }
    };
};

// thunk to fetch queries
export const fetchQueries = () => {
    return async (dispatch) => {
        try {
            const res = await _fetch(`${process.env.REACT_APP_API_URL}/query/my-queries`);
            const data = await res.json();
            if (data.success) {
                const openCount = data.response.filter((q) => q.status === "OPEN").length;
                const last6Queries = data.response.slice(0, 6);
                dispatch({
                    type: SET_QUERIES,
                    payload: { queries: last6Queries, openCount },
                });
            }
        } catch (err) {
            console.error("Error fetching queries:", err);
        }
    };
};

// thunk to fetch FY count
export const fetchFyCount = () => {
    return async (dispatch) => {
        try {
            const res = await _fetch(`${process.env.REACT_APP_API_URL}/fy/userFyCount`);
            const data = await res.json();
            dispatch({ type: SET_FY_COUNT, payload: data.fyCount || 0 });
        } catch (err) {
            console.error("fetch FyCount error:", err);
        }
    };
};


export const fetchTotalEntities = () => {
    return async (dispatch) => {
        try {
            const res = await _fetch(`${process.env.REACT_APP_API_URL}/client/totalEntities`);
            const data = await res.json();
            dispatch({ type: SET_TOTAL_ENTITIES, payload: data.clientCount || 0 });
        } catch (err) {
            console.error("fetch FyCount error:", err);
        }
    };
};
